// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__35fi6","notes":"Notes_notes__2MuiR"};